"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.configureOndcAxiosInstance = exports.configureAuthAxiosInstance = exports.configureLocusAxiosInstance = exports.configureKhetiAxiosInstance = void 0;
const config_1 = __importDefault(require("./auth/config"));
const config_2 = __importDefault(require("./kheti/config"));
const config_3 = __importDefault(require("./locus/config"));
const config_4 = __importDefault(require("./ondc/config"));
// Provides an interface to configure your axios instance.
function setUpInterceptors(instance, requestInterceptorSuccessCb, requestInterceptorErrCb, responseInterceptorSuccessCb, responseInterceptorErrCb) {
    instance.interceptors.request.use((config) => {
        requestInterceptorSuccessCb && requestInterceptorSuccessCb({ ...config });
        return config;
    }, (error) => {
        requestInterceptorErrCb && requestInterceptorErrCb(error);
        return Promise.reject(error);
    });
    instance.interceptors.response.use((response) => {
        responseInterceptorSuccessCb && responseInterceptorSuccessCb(response);
        if (response.data.error == null) {
            return response;
        }
        return Promise.reject(response.data.error);
    }, (error) => {
        responseInterceptorErrCb && responseInterceptorErrCb(error);
        return Promise.reject(error);
    });
}
function configureKhetiAxiosInstance(config) {
    const { appCode, khetiUrl, requestInterceptorSuccessCb, requestInterceptorErrCb, responseInterceptorSuccessCb, responseInterceptorErrCb, } = config;
    config_2.default.defaults.baseURL = khetiUrl;
    config_2.default.defaults.headers.common['APP-CODE'] = appCode;
    setUpInterceptors(config_2.default, requestInterceptorSuccessCb, requestInterceptorErrCb, responseInterceptorSuccessCb, responseInterceptorErrCb);
}
exports.configureKhetiAxiosInstance = configureKhetiAxiosInstance;
function configureLocusAxiosInstance(config) {
    const { appCode, locusUrl, requestInterceptorSuccessCb, requestInterceptorErrCb, responseInterceptorSuccessCb, responseInterceptorErrCb, } = config;
    config_3.default.defaults.baseURL = locusUrl;
    config_3.default.defaults.headers.common['APP-CODE'] = appCode;
    setUpInterceptors(config_3.default, requestInterceptorSuccessCb, requestInterceptorErrCb, responseInterceptorSuccessCb, responseInterceptorErrCb);
}
exports.configureLocusAxiosInstance = configureLocusAxiosInstance;
function configureAuthAxiosInstance(config) {
    const { authUrl, requestInterceptorSuccessCb, requestInterceptorErrCb, responseInterceptorSuccessCb, responseInterceptorErrCb, } = config;
    config_1.default.defaults.baseURL = authUrl;
    setUpInterceptors(config_1.default, requestInterceptorSuccessCb, requestInterceptorErrCb, responseInterceptorSuccessCb, responseInterceptorErrCb);
}
exports.configureAuthAxiosInstance = configureAuthAxiosInstance;
function configureOndcAxiosInstance(config) {
    const { appCode, ondcUrl, requestInterceptorSuccessCb, requestInterceptorErrCb, responseInterceptorSuccessCb, responseInterceptorErrCb, } = config;
    config_4.default.defaults.baseURL = ondcUrl;
    config_4.default.defaults.headers.common['APP-CODE'] = appCode;
    setUpInterceptors(config_4.default, requestInterceptorSuccessCb, requestInterceptorErrCb, responseInterceptorSuccessCb, responseInterceptorErrCb);
}
exports.configureOndcAxiosInstance = configureOndcAxiosInstance;
